import { Icon, IconName, Text } from '@usealloy/component-library';
import { StyledToolbarContainer, StyledToolbarMessage } from '../styles';
import { useContext } from 'react';
import { RuleBuilderContext } from '../../context';
import { ContainerType } from '../../../types';
import { DEFAULT_MESSAGE, SNIPPET_UPGRADE_MESSAGE } from './constants';

interface InfoToolbarProps {
  isUpgradeSnippetFlow: boolean;
}

const InfoToolbar = ({ isUpgradeSnippetFlow }: InfoToolbarProps) => {
  const { containerType } = useContext(RuleBuilderContext);

  const message = isUpgradeSnippetFlow ? SNIPPET_UPGRADE_MESSAGE : DEFAULT_MESSAGE;

  return (
    <StyledToolbarContainer inIsland={containerType === ContainerType.ISLAND}>
      <StyledToolbarMessage>
        <Icon icon={IconName.LightbulbHint} color="var(--cl-gray-1100)" />
        <Text size={2} weight={400}>
          {message}
        </Text>
      </StyledToolbarMessage>
    </StyledToolbarContainer>
  );
};

export default InfoToolbar;
